/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { rangeDependencies } from './dependenciesRange.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createColumn } from '../../factoriesAny.js';
export var columnDependencies = {
  IndexDependencies: IndexDependencies,
  matrixDependencies: matrixDependencies,
  rangeDependencies: rangeDependencies,
  typedDependencies: typedDependencies,
  createColumn: createColumn
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesColumn.generated.js
// module id = 1504
// module chunks = 0